import React from "react";
import "./ResponseModeToggle.css";

/**
 * ResponseModeToggle — segmented control for Quick / Deep response modes.
 * Quick: lightweight grounded RAG, faster text-only answers
 * Deep:  full RAG pipeline + streaming, with manual references when needed
 */
const ResponseModeToggle = ({ responseMode, setResponseMode, translate }) => {
  const modes = [
    {
      value: "quick",
      label: translate ? translate("Quick") : "Quick",
      title: translate ? translate("Fast grounded answer") : "Fast grounded answer",
    },
    {
      value: "deep",
      label: translate ? translate("Deep") : "Deep",
      title: translate ? translate("Full search with manual references") : "Full search with manual references",
    },
  ];

  return (
    <div className="response-mode-container">
      <span className="response-mode-label">
        {translate ? translate("Response Mode") : "Response Mode"}
      </span>
      <div className="response-mode-toggle">
        {modes.map((mode) => (
          <button
            key={mode.value}
            className={`response-mode-btn ${responseMode === mode.value ? "active" : ""}`}
            onClick={() => setResponseMode(mode.value)}
            title={mode.title}
          >
            {mode.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ResponseModeToggle;
